
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/loyalty",
      function () {
        return require("private-next-pages/terms/loyalty.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/loyalty"])
      });
    }
  